import { render, staticRenderFns } from "./ServicesAutocomplete.vue?vue&type=template&id=700c60cd&scoped=true&"
import script from "./ServicesAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ServicesAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./ServicesAutocomplete.vue?vue&type=style&index=0&id=700c60cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c60cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('700c60cd')) {
      api.createRecord('700c60cd', component.options)
    } else {
      api.reload('700c60cd', component.options)
    }
    module.hot.accept("./ServicesAutocomplete.vue?vue&type=template&id=700c60cd&scoped=true&", function () {
      api.rerender('700c60cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Autocomplete/ServicesAutocomplete.vue"
export default component.exports